import { UserPrivate } from '@upright/common/iam/users/types';
import { createCompanySectionTitle } from './company-section';
import { Item, ItemLink, Section, MenuTitleSmall } from '../../../shared-menus';

interface Props {
  user: UserPrivate | undefined;
}

export const SelfSignupCompanyBlock = (props: Props) => {
  const companyTitle = createCompanySectionTitle(
    'self-signup-company',
    props.user?.extraData?.companyNameOnSignup,
    undefined,
  );

  return (
    <Section>
      <MenuTitleSmall>{companyTitle}</MenuTitleSmall>
      <Item>
        <ItemLink to={'/'}>Dashboard</ItemLink>
      </Item>
      <Item>
        <ItemLink to={'/input/products/'}>Products</ItemLink>
      </Item>
    </Section>
  );
};
